module.exports = __webpack_public_path__ + "static/media/SC_H_05.b98fa06d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/clothes/heads/SC_H_05.png
// module id = 147
// module chunks = 0